/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import MoserObject from './MoserObject';
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper

/**
 * <p>Java class for itemNormalizationType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="itemNormalizationType"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="itemNormalizationGroup" type="{}itemNormalizationGroupType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class ItemNormalizationType extends MoserObject{

	itemNormalizationGroup = null;



	/**
	 * Gets the value of the itemNormalizationGroup property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the itemNormalizationGroup property. <p> For example, to add a new item, do as follows: <pre> getItemNormalizationGroup().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ItemNormalizationGroupType}
	 */
	getItemNormalizationGroup() {
		if (!this.itemNormalizationGroup) {
			this.itemNormalizationGroup = [];
		}
		return this.itemNormalizationGroup;
	}

	/**
	 * Gets the value of the <code>itemNormalizationGroup</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>ItemNormalizationGroupType</code> elements, or <code>null</code> if not set
	 */
	basicGetItemNormalizationGroup() {
		return this.itemNormalizationGroup;
	}

	/**
	 * Creates a new instance of <code>ItemNormalizationType</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> ItemNormalizationType</code> object from.
	 * @return {ItemNormalizationType} an object of type <code>ItemNormalizationType</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createItemNormalizationType();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addItemNormalizationGroupAt(position, item) {
		this._addAtAndNotify(this.getItemNormalizationGroup(), position, item, 174, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addItemNormalizationGroup(item) {
		this.addItemNormalizationGroupAt(this.getItemNormalizationGroup().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeItemNormalizationGroupAt(position) {
		this._removeAtAndNotify(this.getItemNormalizationGroup(), position, 174, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeItemNormalizationGroup(item) {
		var i = this.getItemNormalizationGroup().indexOf(item);
		if (i >= 0) {
			this.removeItemNormalizationGroupAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "ItemNormalizationType";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		var clazz;
		if (factory) {
			clazz = factory.createItemNormalizationGroupType().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 174, "itemNormalizationGroup", clazz));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 174:
			this.itemNormalizationGroup = (value);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 174:
			return this.getItemNormalizationGroup();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 174:
			return this.basicGetItemNormalizationGroup();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 174:
			this.addItemNormalizationGroupAt(position, (value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 174:
			this.addItemNormalizationGroup((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 174:
			this.removeItemNormalizationGroupAt(position);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 174:
			this.removeItemNormalizationGroup((item));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/ItemNormalizationType.js